import { Model } from 'json-api-models';
import { orderBy } from 'lodash-es';

import { Models, Schemas } from '../models.ts';

export class Product extends Model<Schemas['products'], Models> {
    get qbank() {
        return orderBy(
            this.packs?.filter((pack) => pack.packType === 'questions'),
            'isSample',
        )[0];
    }

    get qbankSample() {
        return this.packs?.find((pack) => pack.packType === 'questions' && pack.isSample);
    }

    get tutorials() {
        return this.packs?.find((pack) => pack.packType === 'tutorials' && !pack.isSample);
    }

    get tutorialsSample() {
        return this.packs?.find((pack) => pack.packType === 'tutorials' && pack.isSample);
    }

    get stations() {
        return this.packs?.find((pack) => pack.packType === 'stations' && !pack.isSample);
    }

    get stationsSample() {
        return this.packs?.find((pack) => pack.packType === 'stations' && pack.isSample);
    }

    /** The product's names for its learning areas, with eMedici's defaults. */
    get terms() {
        const config = this.config;

        return {
            osces: config?.oscesTerm || 'OSCE Practice',
            station: config?.stationTerm || 'OSCE Station',
            stations: config?.stationsTerm || 'OSCE Stations',
            tutorial: config?.tutorialTerm || 'Case Study',
            tutorials: config?.tutorialsTerm || 'Case Studies',
            exams: config?.examsTerm || 'Mock Exams',
        };
    }

    get hasExams() {
        return this.examCount > 0;
    }

    get isSubscribed() {
        return Boolean(this.subscription?.isActive || this.entitlement);
    }

    get isTrial() {
        return this.subscription?.isActive && this.subscription?.isTrial && !this.entitlement;
    }
}
